import * as React from "react";
import { AppBar as RAAppBar } from "react-admin";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  title: {
    flex: 1,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  subtitle: {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  spacer: {
    flex: 1,
  },
});

const AppBar = (props) => {
  const classes = useStyles();
  return (
    <RAAppBar {...props}>
      <Typography
        variant="h6"
        className={classes.title}
        id="react-admin-title"
      />
      <span className={classes.subtitle}>Application main courante - Grotte Chauvet - Pont d'Arc</span>
      <span className={classes.spacer} />
    </RAAppBar>
  );
};

export default AppBar;
